const Checkbox = ({ status, callback }) => {
  return (
    <div className="toggle-button">
      <div className="btn btn-rect btn-check">
        <input
          type="checkbox"
          className="checkbox"
          checked={status || false}
          onChange={callback}
        />
        <div className="knob">
          <span></span>
        </div>
        <div className="btn-bg"></div>
      </div>
    </div>
  )
}

export default Checkbox
